import React, { Component } from 'react';
import { connect } from 'react-redux';
import { dAPI } from 'appSrc/api';
import { showModal, hideModal } from 'appSrc/redux/actions';
import LoadingReplace from 'appSrc/components/Shards/Loading/LoadingReplace';
import EditListModal from '../../Modals/List/EditListModal';
import { InternalLink, PrimaryButton } from 'appSrc/components/UI';
import ListCoverImage from 'appSrc/components/List/CoverImage';
import { VideoPlayer } from 'appSrc/components/Shards';
import SortableProductsTable from './ProductsTable';
import TagDisplay from 'appSrc/components/Tag/Display';
import { push } from 'connected-react-router';
import { tdcDomainMatch } from 'appSrc/utils/random';
import style from './styles/style.module.css';

class IndividualListPage extends Component {
    constructor( props ) {
        super( props );

        this.state = {
            fetching: true,
            list: {},
            products: [],
        };

        this.loadList( this.props.match.params.lid );
    }
    loadList = ( listid ) => {
        this.props.getList( listid )
        .then( ( list ) => {
            this.setState( {
                fetching: false,
                list: list,
            } );
        } )
        .catch( () => {
            this.props.redirect( '/admin/lists/' );
        } );

        this.props.getListProducts( listid )
        .then( ( products ) => {
            this.setState( { products: products } );
        } )
        .catch( () => {
            this.setState( { products: [] } );
        } );
    }
    openEditModal = () => {
        this.props.showModal( 'editListModal' );
    }
    onEditSubmit = ( updates ) => {
        var calls = [];
        for( var i = 0; i < updates.tags.newTags.length; i++ ) {
            var tag = updates.tags.newTags[ i ];
            calls.push( this.props.addTagToList( this.state.list.listid, tag.tagtext ) );
        }
        for( var j = 0; j < updates.tags.deletedTags.length; j++ ) {
            var dTag = updates.tags.deletedTags[ j ];
            calls.push( this.props.deleteTagFromList( this.state.list.listid, dTag.tagtext ) );
        }
        return Promise.all( calls )
        .then( () => {
            return this.props.updateList( this.state.list.listid, updates.list );
        } )
        .then( ( updatedList ) => {
            this.setState( { list: updatedList } );
            return updatedList;
        } );
    }
    onEditDelete = () => {
        return this.props.deleteList( this.state.list.listid )
        .then(() => {
            this.props.redirect( '/admin/lists' );
        });
    }
    onEditClose = () => {
        this.props.hideModal( 'editListModal' );
    }

    onProductUpdated = ( index, product ) => {
        this.setState( ( altState ) => {
            altState.products[ index ] = product;
            altState.products = altState.products.slice( 0 );
            return altState;
        } );
    }
    onManualProductSort = ( data ) => {
        data = data.map( id => parseInt( id ) );
        var productsList = [];
        this.state.products.forEach( ( product ) => {
            productsList[ data.indexOf( product.desireid ) ] = product;
        } );
        this.setState( { products: productsList } );
        this.props.reorderList( this.state.list.listid, data );
    }


    render() {
        const { fetching, list, products } = this.state;

        if( fetching ) {
            return (
                <section className={ style.individual }>
                    <LoadingReplace />
                </section>
            );
        }

        const author = list.author || {};

        return (
            <section className={ style.individual }>
                <div className={ style.head }>
                    <div className={ style.controls }>
                        <div className={ style.backLink } onClick={ this.props.history.goBack }>Back</div>
                        <div>
                            <PrimaryButton label='Edit List' onClick={ this.openEditModal } />
                            <InternalLink target='_blank' to={ `/${ author.slug }/${ list.slug }` }
                            style={ { marginLeft: '15px' } }>
                                <PrimaryButton reverse label='Public List' />
                            </InternalLink>
                        </div>
                    </div>
                    <div className={ style.individualDetails }>
                        <div>
                            { list.youtube ?
                                <VideoPlayer videoId={ list.youtube } coverImage={ list.coverImage } />
                                :
                                <ListCoverImage coverImage={ list.coverImage } />
                            }
                        </div>
                        <div>
                            <div className={ style.title }>
                                <h2 style={ { marginRight: '15px' } }>{ list.title }</h2>
                            </div>
                            <div className={ style.author }>
                                <p>Created by: <InternalLink to={ `/admin/users/${ author.userid }` }>{ author.displayName }</InternalLink></p>
                            </div>
                            <div className={ style.description }>
                                <p>{ list.description }</p>
                            </div>
                            <div className={ style.categories }>
                                <strong>Categories:</strong>
                                <p>{ list.categories.map( category => category.name ).join( ', ' ) }</p>
                            </div>
                            <div className={ style.categories }>
                                <strong>Interests:</strong>
                                <p>{ list.interests.map( category => category.interest ).join( ', ' ) }</p>
                            </div>
                            <div className={ style.tags }>
                                <TagDisplay tags={ list.tags } multiLine linked={ false } />
                            </div>
                        </div>
                    </div>
                    <div className={ style.tabs }>
                        <div className={ style.tabOption }
                        data-active={ true }>
                            Products ({ list.desires.length })
                        </div>
                    </div>
                </div>
                <div className={ style.body }>
                    { fetching ?
                        <LoadingReplace />
                        :
                        <SortableProductsTable products={ products }
                        onProductUpdated={ this.onProductUpdated }
                        onSort={ this.onManualProductSort } />
                    }
                </div>
                <EditListModal closeModal={ this.onEditClose }
                onSubmit={ this.onEditSubmit }
                onDelete={ this.onEditDelete }
                list={ list } />
            </section>
        );
    }
}

const mapDispatchToProps = ( dispatch ) => {
    return {
        showModal: ( modalName ) => {
            dispatch( showModal( modalName ) );
        },
        hideModal: ( modalName ) => {
            dispatch( hideModal( modalName ) );
        },
        getList: ( listid ) => {
            return dAPI.get( `/admin/lists/${ listid }` );
        },
        updateList: ( listid, data ) => {
            return dAPI.patch( `/lists/${ listid }`, dAPI.clean.list( data ) );
        },
        deleteList: ( listid ) => {
            return dAPI.delete( `/lists/${ listid }` );
        },
        addTagToList: ( listid, newTag ) => {
            return dAPI.post( `/lists/${ listid }/tag`, { tag: newTag } );
        },
        deleteTagFromList: ( listid, tagtext ) => {
            return dAPI.delete( `/lists/${ listid }/tag/${ tagtext }` );
        },
        reorderList: ( listid, orderedDesireIds ) => {
            return dAPI.patch( `/desires/orderByList/${ listid }`, { orderedDesireIds } );
        },
        getListProducts: ( listid ) => {
            return dAPI.get( `/lists/${ listid }/desires?limit=9999` );
        },
        redirect: ( url ) => {
            dispatch( push( url ) );
        },
    };
};

export default connect( null, mapDispatchToProps )( IndividualListPage );
